import { type FC } from "react";
import { PaidMediaTabsDashboard } from "../components";

const PaidMediaDashboard: FC = () => {
  return (
    <div className="paid-media-dashboard-with-data">
      <PaidMediaTabsDashboard />
    </div>
  );
};

export default PaidMediaDashboard;
